import { lazy } from 'react';

export const lazyDelay = (imp: () => any, delay = 1000) =>
  lazy(() => {
    return Promise.all([imp(), new Promise((res) => setTimeout(res, delay))]).then(([El]) => El);
  });
